import { arrayOrEmpty, cleanString, numberOrNull } from './helpers';

/* ============================================================
   NEARBY PLACES - FRONTEND -> BACKEND
============================================================ */

export function convertDistanceToKm(distance, unit) {
    const value = numberOrNull(distance);

    if (value === null) return null;

    if (unit === 'm') return value / 1000;

    if (unit === 'mi') return value * 1.60934;

    return value;
}

export function transformNearbyPlaces(nearbyPlaces = []) {
    return arrayOrEmpty(nearbyPlaces)
        .map((place) => ({
            name: cleanString(place?.name),

            // the step's "description" box is stored as the place type/note
            type: cleanString(place?.description ?? place?.type),

            distanceKm:
                place?.distanceKm !== undefined
                    ? numberOrNull(place.distanceKm)
                    : convertDistanceToKm(place?.distance, place?.distanceUnit)
        }))
        .filter((place) => place.name);
}

/* ============================================================
   NEARBY PLACES - BACKEND -> FRONTEND
   ------------------------------------------------------------
   The backend only stores distanceKm (it doesn't remember
   which unit the organizer originally typed the distance in),
   so this always comes back displayed in km even if it was
   entered in metres or miles - a pre-existing, one-way
   conversion, not something the reverse mapper can undo.
============================================================ */

export function reverseNearbyPlaces(nearbyPlaces = []) {
    return arrayOrEmpty(nearbyPlaces).map((place) => ({
        name: cleanString(place?.name),
        distance: place?.distanceKm ?? '',
        distanceUnit: 'km',
        description: cleanString(place?.type)
    }));
}

/* ============================================================
   FAQ - FRONTEND -> BACKEND
============================================================ */

export function transformFaqs(faqs = []) {
    return arrayOrEmpty(faqs)
        .map((faq, index) => ({
            question: cleanString(faq?.question),

            answer: cleanString(faq?.answer),

            displayOrder: numberOrNull(faq?.displayOrder) ?? index
        }))
        .filter((faq) => faq.question && faq.answer);
}

/* ============================================================
   FAQ - BACKEND -> FRONTEND
============================================================ */

export function reverseFaqs(faqs = []) {
    return arrayOrEmpty(faqs)
        .slice()
        .sort((a, b) => (numberOrNull(a?.displayOrder) ?? 0) - (numberOrNull(b?.displayOrder) ?? 0))
        .map((faq) => ({
            question: cleanString(faq?.question),
            answer: cleanString(faq?.answer)
        }));
}
